export default "__VITE_ASSET__DrYO8P6Z__"